import React from 'react';
import { Tooltip, Icon } from 'antd';
import PropTypes from 'prop-types';

const HelpTooltip = ({ title }) => (
	<Tooltip title={title}>
		<Icon type='question-circle' style={{ marginLeft: 6, color: 'rgba(0, 0, 0, 0.45)' }} />
	</Tooltip>
);

HelpTooltip.propTypes = {
	title: PropTypes.string.isRequired,
};

export default HelpTooltip;



// WEBPACK FOOTER //
// ./src/components/helpTooltip.jsx